export const messageForSigning = (signingAddress: string) => `By signing this message, you confirm that the wallet is a trusted one ${signingAddress}; Data: `
